import { observer } from 'mobx-react';

function MainNavSkeleton() {
  return (
    <div className="bg-white">
      <div className="px-[5px] py-[5px] lg:px-[30px] lg:py-[20px] bg-white animate-pulse max-w-clientPortalMaxWidth mx-auto w-full">
        <div className="px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-[40px] h-[40px] bg-gray-200"></div>
            <div className="hidden lg:flex w-36 h-8 bg-gray-200 rounded-full mr-[30px]"></div>
            <nav className="hidden lg:flex space-x-4">
              {[...Array(5)].map((_, index) => (
                <div key={index} className="w-[100px] h-8 bg-gray-300"></div>
              ))}
            </nav>
          </div>
          <div className="flex items-center">
            <svg
              className="w-[40px] h-[40px] text-gray-200 dark:text-gray-700 me-4"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(MainNavSkeleton);
